import script from "./ToucanWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToucanWidget.vue?vue&type=script&setup=true&lang=ts"

import "./ToucanWidget.vue?vue&type=style&index=0&id=3bc847b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc847b2"]])

export default __exports__